import React, {Component} from 'react'
import {withRouter} from "react-router-dom";
import {Button, Checkbox, Divider, Form, FormGroup, Grid, Header, Icon, Modal, Popup, Segment} from "semantic-ui-react";
import {CustomContainer} from '../../../custom-common';
import {connect} from "react-redux";
import Footer from "../../../footer";
import FullScreenPageMenu from "../../../fullScreenPageMenu";
import ChangeSteps from "../changeSteps";
import {convertDisplayDateFormatToServer, isCoveredState, resolveAddDependentRelationship, resolveErrorMessage, WHEN_ROUTE} from "../../../../utils/common";
import moment from "moment";
import ErrorInput from "../../../../components/errorInput";
import FormSelectState from "../../../../components/formSelectState";
import {setDependent, setDependentsId, setMaritalStatus, setPlanChangeInitialData, setTotalDependents} from "../../../../actions/planChangeActions";
import axios from "axios";
import STRATEGIC_PARTNER from "../../../../constants/strategicPartners";
import {CustomModalHeader, DOBInput} from "../../../custom-common";

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        planChangeDependents: state.planChange.planChangeDependents,
        stateOptions: state.planChange.states,
        genderOptions: state.planChange.genderOptions,
        childMaxEligibilityAge: state.initialData.contract.childMaxEligibilityAge,
        nameSuffixOptions: state.planChange.nameSuffixOptions,
        dependents: state.initialData.dependents,
        relationshipOptions: state.planChange.relationshipOptions,
        haveStepChildren: state.planChange.haveStepChildren,
        contractTerms: state.certificate.ratedClass.contractTerms
    }
};

class AddOtherDependent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            validationErrorsMap: new Map(),
            invalidZipCode: false,
            invalidDepZipCode: false,
            curDependent: {
                showSpouseWarning: false,
                displayChildEligibilityAgreement: false,
                selectedChildButNotAvailable: false,
                selectedSpouseButNotAvailable: false,
                selectedRelationship: '',
                firstName: '',
                middleName: '',
                suffix: '',
                lastName: '',
                birthdate: '',
                gender: '',
                addressSameAsEmployee: true,
                ssn: '',
                relationship: '',
                streetAddress: '',
                appartment: '',
                zipCode: '',
                city: '',
                state: '',
                userAgrees: false,
            },
            showDependentsSubmitErrorMessage: false,
            added: false
        }
    }

    componentDidMount() {
        this.loadData().then();
    }

    loadData = async () => {
        try {
            this.setState({loading: true})
            const result = await axios.post("/api/member/v2/preparePlanChanges", null, {headers: {'Content-Type': 'application/json'}});
            const data = result.data;
            const payload = {
                genderOptions: data.genderOptions,
                nameSuffixOptions: data.nameSuffixOptions,
                states: data.states,
                relationshipOptions: data.relationshipOptions,
                countries: data.countries,
                highDeductibleOptions: data.highDeductibleOptions,
                coPayOptions: data.coPayOptions,
                disposableIncomeOptions: data.disposableIncomeOptions,
                dependentsOptions: data.dependentsOptions,
                costPerOptions: data.costPerOptions,
                familyTierOptions: data.familyTierOptions
            }
            this.props.dispatch(setPlanChangeInitialData(payload))
            this.setState({loading: false, prepareError: ''})

        } catch (e) {
            console.warn(e)
            this.setState({loading: false, prepareError: resolveErrorMessage(e, "An unexpected error ocurred")})
        }
    }

    openModal = () => {
        let curDependent = {
            firstName: '',
            middleName: '',
            suffix: '',
            lastName: '',
            relationship: resolveAddDependentRelationship(this.props.qleReason),
            gender: '',
            ssn: '',
            birthdate: '',
            addressSameAsEmployee: true,
            streetAddress: '',
            appartment: '',
            zipCode: '',
            city: '',
            state: '',
            userAgrees: false,
            showSpouseWarning: false,
            displayChildEligibilityAgreement: false,
            selectedChildButNotAvailable: false,
            selectedSpouseButNotAvailable: false,
            selectedRelationship: '',
        }

        this.setState({
            showModal: true,
            curDependent: curDependent,
            showDependentsSubmitErrorMessage: false
        })
    }

    onBackHandler = () => {
        this.props.history.push(WHEN_ROUTE);
    }

    handleDependentFormChange = (event, {value, name}) => {
        if (name === "zipCode") {
            const valNum = parseInt(value, 10);
            if (isNaN(valNum) && value !== "") {
                return;
            }
        }
        this.setState(
            {
                curDependent: {
                    ...this.state.curDependent,
                    [name]: value
                }
            })
    }

    closeModal = () => {
        this.setState({
            showModal: false,
            curDependent: {}
        })
    }

    renderDependentForm = () => {
        const {curDependent, invalidDepZipCode} = this.state;
        const {stateOptions, genderOptions, childMaxEligibilityAge, nameSuffixOptions, dependents, planChangeDependents, relationshipOptions} = this.props;
        const {
            relationship, firstName, lastName, birthdate, gender, addressSameAsEmployee, ssn, streetAddress, appartment, city, state, zipCode, userAgrees,
            displayChildEligibilityAgreement, selectedChildButNotAvailable, selectedSpouseButNotAvailable, middleName, suffix,
        } = curDependent;

        const error = this.validAddForm();

        const isChild = relationship === "Child";
        const disableFields = selectedChildButNotAvailable || selectedSpouseButNotAvailable;
        const invalidState = !addressSameAsEmployee && !!state && !isCoveredState(state);

        const totalDependents = dependents.concat(planChangeDependents);
        const hasSpouse = !!totalDependents && totalDependents.filter(dep => dep.relToEmployee === "Spouse" || dep.relToEmployee === "Domestic Partner").length > 0;
        let filteredRelationshipOptions = relationshipOptions;
        if (hasSpouse) {
            filteredRelationshipOptions = relationshipOptions.filter((r) => r.text !== "Spouse" && r.text !== "Domestic Partner");
        }
        return (
            <Form>
                <Header as="h4" color="green">Role</Header>
                <Form.Select value={relationship || ''} fluid width={12}
                             name={"relationship"}
                             options={filteredRelationshipOptions}
                             required label={"Relationship to employee"}
                             onChange={this.handleDependentFormChange}
                />

                <Header as="h4" color="green">Details</Header>
                <Form.Group widths="equal">
                    <ErrorInput fluid required={true}
                                label="First name"
                                name='firstName'
                                disabled={disableFields}
                                value={!firstName ? '' : firstName}
                                onChange={this.handleDependentFormChange}/>

                    <ErrorInput fluid
                                label="Middle name"
                                name='middleName'
                                disabled={disableFields}
                                value={!middleName ? '' : middleName}
                                onChange={this.handleDependentFormChange}/>
                </Form.Group>

                <Form.Group widths="equal">
                    <ErrorInput fluid required={true}
                                label="Last name"
                                name='lastName'
                                disabled={disableFields}
                                value={!lastName ? '' : lastName}
                                onChange={this.handleDependentFormChange}/>

                    <Form.Select value={!suffix ? '' : suffix}
                                 fluid
                                 options={nameSuffixOptions} name={"suffix"}
                                 label="Suffix"
                                 onChange={this.handleDependentFormChange}/>
                </Form.Group>

                <Form.Group widths="equal">
                    <Form.Field required>
                        <DOBInput value={!!birthdate ? birthdate : ''} fluid
                                  name={"birthdate"}
                                  label={"Date of birth"}
                                  setFormError={(msg) => {
                                      this.setState({
                                          dobError: msg,
                                      })
                                  }}
                                  onFocus={() => {
                                      this.handleDependentFormChange(null, {
                                          value: false,
                                          name: 'displayChildEligibilityAgreement'
                                      });
                                  }}
                                  onChange={(event, {value}) => {
                                      this.handleDependentFormChange(event, {value, name: 'birthdate'});
                                  }}
                                  onBlur={() => {
                                      const age = moment().diff(birthdate, 'years');
                                      if (age >= childMaxEligibilityAge) {
                                          this.handleDependentFormChange(null, {
                                              value: true,
                                              name: 'displayChildEligibilityAgreement'
                                          })
                                      }
                                  }}
                                  required
                        />
                    </Form.Field>

                    <Form.Select fluid required label={"Gender"} disabled={disableFields}
                                 value={gender}
                                 name={"gender"}
                                 options={genderOptions}
                                 onChange={this.handleDependentFormChange}
                    />
                </Form.Group>

                {(!!displayChildEligibilityAgreement && !!isChild) &&
                <Form.Field>
                    <div style={{backgroundColor: '#f5f5f5', padding: '1em'}} className={"small"}>
                        <b>In order for your child over {childMaxEligibilityAge} to be covered, the following must
                            apply—</b>
                        <ul>
                            <li>the child is incapable of self-sustaining employment because of a mental or physical
                                disability; and
                            </li>
                            <li>the child is chiefly dependent on You for support and maintenance; and</li>
                            <li>proof is provided of the disability upon our request (proof will be required at the time
                                of claim).
                            </li>
                        </ul>
                        <Checkbox label={"I agree"} checked={userAgrees} onClick={() => {
                            const newValue = this.state.curDependent;
                            newValue.userAgrees = !userAgrees
                            this.setState({
                                curDependent: {...newValue},
                            });
                        }}/>
                    </div>
                </Form.Field>
                }

                <Form.Group>
                    <Form.Input label={<label>Social Security Number</label>}
                                width={6} value={ssn} name={"ssn"}
                                disabled={disableFields}
                                onChange={(e, {value}) => {
                                    const isNumeric = value.toLocaleLowerCase() === value.toUpperCase();
                                    if (value.length <= 9 && isNumeric) {
                                        this.handleDependentFormChange(e, {name: "ssn", value: value});
                                    }
                                }}/>

                </Form.Group>
                <Header as="h4" color="green">Address</Header>
                <Form.Group>
                    <Form.Field width={6}>
                        <Checkbox label="Same as employee"
                                  name={"addressSameAsEmployee"}
                                  checked={addressSameAsEmployee}
                                  onChange={(e) => {
                                      this.handleDependentFormChange(e, {
                                          name: "addressSameAsEmployee",
                                          value: !addressSameAsEmployee
                                      })
                                  }}
                        />
                    </Form.Field>
                </Form.Group>
                {!addressSameAsEmployee &&
                <React.Fragment>
                    <FormGroup widths={'equal'}>
                        <ErrorInput fluid required={true}
                                    label="Street address"
                                    name='streetAddress'
                                    disabled={disableFields}
                                    value={!streetAddress ? '' : streetAddress}
                                    onChange={this.handleDependentFormChange}/>

                        <Form.Input label="Apartment" disabled={disableFields}
                                    value={!appartment ? '' : appartment}
                                    name={"appartment"} onChange={this.handleDependentFormChange}/>
                    </FormGroup>
                    <FormGroup widths={'equal'}>
                        <Form.Field>
                            <Form.Input label="Zip code" required
                                        value={!zipCode ? '' : zipCode}
                                        error={invalidDepZipCode}
                                        name={"zipCode"}
                                        onFocus={() => {
                                            this.setState({
                                                invalidDepZipCode: false,
                                            });
                                        }}
                                        onChange={this.handleDependentFormChange}
                                        onBlur={() => {
                                            const isError = !zipCode || zipCode.length === 0 || ((zipCode.length > 5 && zipCode.length < 9) || zipCode.length < 5 || zipCode.length > 9);
                                            this.setState({
                                                invalidDepZipCode: isError || isNaN(zipCode * 1),
                                            })
                                        }}/>
                            {!!invalidDepZipCode && <small style={{color: 'red'}}>Invalid zip code</small>}
                        </Form.Field>

                        <ErrorInput fluid required={true}
                                    label={"City"}
                                    name='city'
                                    disabled={disableFields}
                                    value={!city ? '' : city}
                                    onChange={this.handleDependentFormChange}/>
                    </FormGroup>
                    <FormGroup>
                        <FormSelectState name={"state"}
                                         initialValue={state}
                                         options={stateOptions}
                                         disabled={disableFields}
                                         onChange={this.handleDependentFormChange}/>
                    </FormGroup>
                </React.Fragment>
                }

                <Segment basic vertical clearing style={{paddingBottom: 0}}>
                    <Button primary
                            disabled={!!error || invalidState || invalidDepZipCode ||
                            (!!isChild && moment().diff(birthdate, 'years') >= childMaxEligibilityAge && !userAgrees) ||
                            (!!displayChildEligibilityAgreement && !!isChild && !userAgrees)}
                            floated={"right"}
                            onClick={() => {
                                this.submitNewDependent()
                            }}>
                        Save
                    </Button>
                    <Button color='grey' basic floated={"right"} onClick={this.closeModal}>Cancel</Button>
                </Segment>
            </Form>
        )
    }

    submitNewDependent = () => {
        const {curDependent} = this.state;
        const {planChangeDependents} = this.props;
        let dependentIdx = !!planChangeDependents ? planChangeDependents.length : 0;
        const dependent = {
            firstName: curDependent.firstName,
            middleName: curDependent.middleName,
            lastName: curDependent.lastName,
            suffix: curDependent.suffix,
            birthDate: convertDisplayDateFormatToServer(curDependent.birthdate),
            gender: curDependent.gender,
            ssn: curDependent.ssn,
            relToEmployee: curDependent.relationship,
            addressSameAsEmployee: curDependent.addressSameAsEmployee,
            address: !curDependent.addressSameAsEmployee ? {
                streetAddress: curDependent.streetAddress,
                appartment: curDependent.appartment,
                zipCode: curDependent.zipCode,
                city: curDependent.city,
                state: curDependent.state
            } : null,
            isQualifiedForCoverage: curDependent.userAgrees,
            isQle: false
        }
        this.props.dispatch(setDependent(dependent, dependentIdx));
        this.setState({added: true})
        this.closeModal();
    }

    validAddForm = () => {
        const {curDependent} = this.state;
        const required = ['firstName', 'lastName', 'birthdate', 'gender', 'relationship'];
        let error = false;

        for (let i = 0; i < required.length; i++) {
            let item = required[i];
            if (!curDependent[item] || curDependent[item].length === 0) {
                error = true;
                break;
            }
        }

        if (!curDependent.addressSameAsEmployee) {
            const requiredIfAddress = ['streetAddress', 'zipCode', 'city', 'state'];
            for (let i = 0; i < requiredIfAddress.length; i++) {
                let item = requiredIfAddress[i];
                if (!curDependent[item] || curDependent[item].length === 0) {
                    error = true;
                    break;
                }
            }
        }

        return error;
    }

    setFamilyInfo = () => {
        const {planChangeDependents, dependents} = this.props;
        const totalDependents = dependents.concat(planChangeDependents);
        this.props.dispatch(setTotalDependents(totalDependents));
        const hasSpouse = totalDependents.filter(dependent => dependent.relToEmployee === "Spouse").length > 0;
        const maritalStatus = !!hasSpouse ? 1 : 2;
        this.props.dispatch(setMaritalStatus(maritalStatus))
        const children = totalDependents.filter(dependent => dependent.relToEmployee === "Child");
        let hasChildUnder18 = false;
        if (!!children) {
            const mNow = moment(Date.now());
            const childUnder18 = children.filter(child => mNow.diff(moment(child.birthDate), "years") < 18)
            hasChildUnder18 = !!childUnder18 && childUnder18.length > 0
        }
        const dependentsId = !children ? 3 : !!hasChildUnder18 ? 1 : 2;
        this.props.dispatch(setDependentsId(dependentsId));
    }

    onNext = () => {
        this.setFamilyInfo();
        this.props.history.push("/change/update/success")
    }

    onCancel = () => {
        this.props.history.push("/plan")
    }

    render() {
        const {showModal, added} = this.state;
        const {planChangeDependents, dependents, contractTerms} = this.props;
        const button = <Button primary content="Next step" onClick={this.onNext} disabled={!added}/>;
        const link = <span className={"linkText"} onClick={this.onCancel}>or Cancel</span>
        const infoIcon = <Icon circular name={'info'}
                               style={{color: 'black', marginLeft: '1em', fontSize: '10px', cursor: 'pointer'}}
                               onClick={() => this.setState({displayBWPInfo: true})}/>;
        return (
            <React.Fragment>
                {!!showModal && <Modal size={'tiny'} onClose={this.closeModal} open={showModal}>
                    <CustomModalHeader title={"Add dependent"} onClose={this.closeModal} className="customModalHeader"/>
                    <Modal.Content className={"small"}>
                        {this.renderDependentForm()}
                    </Modal.Content>
                </Modal>}
                <FullScreenPageMenu center={"Change my benefits"}/>
                <div className="member-main-container" style={{background: 'white'}}>
                    <ChangeSteps activeStepIdx={0}/>

                    <Grid container stackable columns={1} centered>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <Header as={"h2"} color="green">Add other family members</Header>
                                <p className={"neutral700Text"}>To update your {STRATEGIC_PARTNER.LABEL} coverage again, add other family
                                    members not related to your qualifying life event.</p>
                                <Divider hidden/>
                                {!!contractTerms && <React.Fragment>
                                    <CustomContainer basic className={"bkgLinen"}>
                                        <span className={"smaller"}><b>HEADS UP!</b> Although you are able to add other family members to your plan,
                                            their coverage will be subject to the benefit waiting period</span><Popup
                                        position={'top left'}
                                        on={'hover'}
                                        style={{cursor: 'pointer'}}
                                        trigger={
                                            <span>{infoIcon}</span>
                                        }
                                    >
                                        <span className={"smaller"}>If you enroll or add a family member outside of an open enrollment period (annual, new hire, or other qualifying life event), your benefits or any increases are subject to a {contractTerms.benefitWaitingPeriod}-day waiting period from effective date of change. Any diagnoses that occur during the waiting period will not be covered.</span>
                                    </Popup>
                                    </CustomContainer>
                                    <Divider hidden/>
                                </React.Fragment>}
                                {(!!dependents && dependents.length > 0) &&
                                <React.Fragment><p><b>Current family members</b></p>
                                    {dependents.map(((dependent, index) => {
                                        const mNow = moment(Date.now());
                                        const mDate = moment(dependent.birthDate)
                                        const age = mNow.diff(mDate, "years")
                                        return <CustomContainer key={index}>
                                            <b>{dependent.firstName} {dependent.middleName ? dependent.middleName + ' ' : null}{dependent.lastName}</b><br/>
                                            {dependent.relToEmployee}, Age {age}
                                        </CustomContainer>
                                    }))}
                                    <Divider hidden/>
                                </React.Fragment>}
                                {(!!planChangeDependents && planChangeDependents.length > 0) && <React.Fragment>
                                    <p><b>Added family members</b></p>
                                    {planChangeDependents.map(((dependent, index) => {
                                        const mNow = moment(Date.now());
                                        const mDate = moment(dependent.birthDate)
                                        const age = mNow.diff(mDate, "years")
                                        return <CustomContainer key={index}>
                                            <b>{dependent.firstName} {dependent.middleName ? dependent.middleName + ' ' : null}{dependent.lastName}</b><br/>
                                            {dependent.relToEmployee}, Age {age}
                                        </CustomContainer>
                                    }))}
                                </React.Fragment>}
                                <Button primary basic onClick={() => this.openModal()}>+ Add dependent</Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Footer showTopFooter={true} hasToDisplayCarrierDisclaimer
                            button={button} link={link}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps)(withRouter(AddOtherDependent));
